import {
  getRemovingUserFromSelectedTeamDefaultErrorMessage,
  getRemovingUserFromSelectedTeamLoading,
} from 'gcs-common/slices/administration/teams/teamsSelectors';
import { resetRemovingUserFromSelectedTeamDefaultErrorMessage } from 'gcs-common/slices/administration/teams/teamsSlice';
import { removeUserFromSelectedTeam } from 'gcs-common/slices/administration/teams/teamsThunks';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AgentPropType from '../../../../models/AgentPropType';
import TeamPropType from '../../../../models/TeamPropType';
import { showFailureNotification } from '../../../../slices/notifications/ShowNotificationThunk';
import Button from '../../../Button/Button';
import styles from './styles.module.scss';

const TeamRemoveUser = ({ user, team, onCancel, onSuccess }) => {
  const dispatch = useDispatch();
  const defaultErrorMessage = useSelector(getRemovingUserFromSelectedTeamDefaultErrorMessage);
  const isDeleting = useSelector(getRemovingUserFromSelectedTeamLoading);

  useEffect(() => {
    if (defaultErrorMessage) {
      dispatch(
        showFailureNotification(defaultErrorMessage, dispatch(resetRemovingUserFromSelectedTeamDefaultErrorMessage())),
      );
    }
  }, [defaultErrorMessage, dispatch]);

  useEffect(() => {
    dispatch(resetRemovingUserFromSelectedTeamDefaultErrorMessage());
  }, [dispatch]);

  const { id: userId, friendlyName } = user;
  const { id: teamId } = team;

  const handleDelete = useCallback(async () => {
    const result = await dispatch(removeUserFromSelectedTeam({ teamId, userId }));
    if (!result.error) {
      onSuccess();
    }
  }, [dispatch, teamId, onSuccess, userId]);

  return (
    <div className={styles.column}>
      Möchten Sie die den Nutzer
      {' "'}
      {friendlyName}
      {'" '}
      aus dem Team entfernen?
      <div className={styles.buttonRow}>
        <Button className={styles.modalButtonSecondary} type="button" disabled={isDeleting} onClick={onCancel}>
          Abbrechen
        </Button>
        <Button className={styles.modalButton} type="button" onClick={handleDelete} disabled={isDeleting}>
          Entfernen
        </Button>
      </div>
    </div>
  );
};

TeamRemoveUser.propTypes = {
  team: TeamPropType.isRequired,
  user: AgentPropType.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default TeamRemoveUser;
